import validate from "/home/circleci/project/node_modules/.pnpm/nuxt@3.9.3_@parcel+watcher@2.4.0_@types+node@18.19.8_encoding@0.1.13_eslint@8.56.0_magi_6241a73a4111dd4fedb3393ad5f6ae85/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/circleci/project/node_modules/.pnpm/nuxt@3.9.3_@parcel+watcher@2.4.0_@types+node@18.19.8_encoding@0.1.13_eslint@8.56.0_magi_6241a73a4111dd4fedb3393ad5f6ae85/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}